import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

export interface NewBlock {
  height: string;
  hash: string;
  timestamp: string;
  validator: string;
  txCount: number;
  isNew?: boolean;
}

interface BlockState {
  // Real-time blocks from WebSocket
  realtimeBlocks: NewBlock[];
  maxBlocks: number;

  // UI state
  isScrolling: boolean;
  autoScroll: boolean;

  // Actions
  addRealtimeBlock: (block: NewBlock) => void;
  addRealTimeBlocks: (blocks: NewBlock[]) => void;
  clearRealtimeBlocks: () => void;
  setAutoScroll: (enabled: boolean) => void;
  setIsScrolling: (scrolling: boolean) => void;
}

export const useBlockStore = create<BlockState>()(
  subscribeWithSelector(set => ({
    // Initial state
    realtimeBlocks: [],
    maxBlocks: 10000, // Keep last 100 blocks for performance
    isScrolling: false,
    autoScroll: true,

    // Actions
    addRealtimeBlock: (block: NewBlock) => {
      set(state => {
        const newBlocks = [block, ...state.realtimeBlocks].slice(0, state.maxBlocks);
        return {
          realtimeBlocks: newBlocks,
        };
      });
    },

    addRealTimeBlocks: (blocks: NewBlock[]) => {
      set(state => {
        const newBlocks = [...blocks, ...state.realtimeBlocks].slice(0, state.maxBlocks);
        return {
          realtimeBlocks: newBlocks,
        };
      });
    },

    clearRealtimeBlocks: () => {
      set({ realtimeBlocks: [] });
    },

    setAutoScroll: (enabled: boolean) => {
      set({ autoScroll: enabled });
    },

    setIsScrolling: (scrolling: boolean) => {
      set({ isScrolling: scrolling });
    },
  })),
);
